/**
 * Check if provided element is visible.
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function isVisible(element) {
  return !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
  );
}
